import { render, staticRenderFns } from "./public-edit.vue?vue&type=template&id=f26ab4ea&scoped=true"
import script from "./public-edit.vue?vue&type=script&lang=ts"
export * from "./public-edit.vue?vue&type=script&lang=ts"
import style0 from "./public-edit.vue?vue&type=style&index=0&id=f26ab4ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f26ab4ea",
  null
  
)

export default component.exports